import { faAddressBook } from "@fortawesome/free-solid-svg-icons/faAddressBook";
import { faFileLines } from "@fortawesome/free-solid-svg-icons/faFileLines";
import { faHandshake } from "@fortawesome/free-solid-svg-icons/faHandshake";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faGauge } from "@fortawesome/free-solid-svg-icons/faGauge";
import { faChartPie } from "@fortawesome/free-solid-svg-icons/faChartPie";
import { faCodeBranch } from "@fortawesome/free-solid-svg-icons/faCodeBranch";
import { faEnvelopeOpenText } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpenText";
import { faUserGear } from "@fortawesome/free-solid-svg-icons/faUserGear";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faUsersGear } from "@fortawesome/free-solid-svg-icons/faUsersGear";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons/faBullhorn";
import { faMapSigns } from "@fortawesome/free-solid-svg-icons/faMapSigns";
import { faCube } from "@fortawesome/free-solid-svg-icons/faCube";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { ActivityEntityKind } from "../model/activity/types/ActivityEntityKind.enum";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export const EntityIcons = {
  Entries: faAddressBook,
  Forms: faFileLines,
  Deals: faHandshake,
  Tasks: faCheck,
  Modules: faCube,
};

export const EntityIconsByActivityKind: Record<
  ActivityEntityKind,
  IconDefinition
> = {
  [ActivityEntityKind.ENTRY]: EntityIcons.Entries,
  [ActivityEntityKind.TASK]: EntityIcons.Tasks,
  [ActivityEntityKind.KANBAN_CARD]: EntityIcons.Deals,
  [ActivityEntityKind.MODULE]: EntityIcons.Modules,
  [ActivityEntityKind.KANBAN_COLUMN]: EntityIcons.Modules,
  [ActivityEntityKind.KANBAN]: EntityIcons.Deals,
  [ActivityEntityKind.FORM]: EntityIcons.Forms,
};

export const PageIcons = {
  Dashboard: faGauge,
  Reports: faChartPie,
  Integration: faCodeBranch,
  Campaigns: faEnvelopeOpenText,
  Admin: faUserGear,
  AdminSearchUsers: faUsers,
  AdminPSAUsers: faBullhorn,
  AdminRoadmap: faMapSigns,
  Search: faSearch,
  Profile: faUser,
  Permissions: faUsersGear,
  TeamChat: faComments,
};
